// @flow
import React from 'react'
import CategoryTags from '../components/CategoryTags'
import OpportunityDate from './OpportunityDate'
import Date from './Date'
import type { OpportunityType } from '../types/OpportunityType'
import OpportunityTagsReviewed from './OpportunityTagsReviewed'

const Opportunity = ({
  id,
  name,
  organization,
  shareUrl,
  guidelines,
  tags,
  tagsModifiedByOrg,
  startDateUtc,
  expireDateUtc,
  createdOnUtc,
  live,
  submissionCount,
  galleryViewEnabled,
  galleryViewVotingEnabled,
  galleryViewVoteCount,
}: OpportunityType) => (
  <dl className="dl-horizontal">
    <dt><h3>Opportunity</h3></dt>
    <dd>
      <OpportunityTagsReviewed params={{ id }} />
    </dd>
    <dt>Name</dt>
    <dd>
      <a href={shareUrl} target="submit">
        {name} <span role="img" aria-label="link emoji">🔗</span>
      </a>
    </dd>
    <dt>Created on</dt>
    <dd>
      <Date date={createdOnUtc} />
    </dd>
    <dt>Duration</dt>
    <dd>
      <OpportunityDate
        startDateUtc={startDateUtc}
        expireDateUtc={expireDateUtc}
        live={live}
      />
    </dd>
    <dt>Submissions</dt>
    <dd>
      {submissionCount}
    </dd>
    <dt>Public Gallery</dt>
    <dd>
      {galleryViewEnabled ? 'True' : 'False'}
    </dd>
    <dt>Public Gallery Voting</dt>
    <dd>
      {galleryViewVotingEnabled ? 'True' : 'False'}
    </dd>
    <dt>Public Gallery Votes</dt>
    <dd>
      {galleryViewVoteCount}
    </dd>
    <dt>Opportunity Guidelines</dt>
    <dd>
      {guidelines
        ? <div dangerouslySetInnerHTML={{ __html: guidelines }} />
        : 'No Guidelines'}
    </dd>
    <dt>Opportunity Tags</dt>
    <dd>
      <CategoryTags disabled={tagsModifiedByOrg} value={tags} id={id} />
    </dd>
  </dl>
)

export default Opportunity



// WEBPACK FOOTER //
// ./src/components/Opportunity.js